module.exports = __webpack_public_path__ + "static/linkedin-logo-6b7e8eee04bc206fadc971840497583e.mp4";